<template>
    <div>
        <Modal
            class-name="set-pump-by-wallet"
            v-model="visable"
            v-show="visable"
            :mask-closable="true"
            :width="100"
            :title="$t('lang.set_pump_by_w_title')"
            :footer-hide="true"
        >
            <div class="box" v-loading="loading">
                <p style="margin-bottom: 20px;">
                    {{$t('lang.set_pump_by_w_p_1')}} <span style="color: #ffab00;">{{ targetWallet }}</span> {{$t('lang.set_pump_by_w_p_2')}}
                </p>
                <Form :label-width="120" v-bind:key="index" v-for="(item, index) in portWallets">
                    <FormItem :label="item.addr">
                        <Slider v-model="item.ratio" :step="0.01" :min="0" :max="100" show-input></Slider>
                    </FormItem>
                </Form>
                <div>
                    <ButtonGroup style="width: 100%;">
                        <Button @click.native="save()" style="margin-bottom: 10px;width: 50%;" type="success" long>{{$t('lang.set_pump_by_w_p_3')}}</Button>
                        <Button @click.native="reset()" style="margin-bottom: 10px;width: 50%;" type="primary" long>{{$t('lang.set_pump_by_w_p_4')}}</Button>
                    </ButtonGroup>
                    <Button @click.native="hide()" type="default" long>{{$t('lang.set_pump_by_w_p_5')}}</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>
<script>
import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'


export default {
    data() {
        return {
            loading: false,
            visable: false,
            targetWallet: '',
            portId: '',
            portWallets: [],
            callback: null
        }
    },
    components: {
    },
    computed:{
    },
    mounted() {
       
    },
    methods:{
        ...mapActions('port', [
            'updatePorts'
        ]),
        show(row, portId, portWallets, callback) {
            this.portWallets = []

            portWallets.forEach(item => {
                this.portWallets.push({
                    addr: item.addr,
                    id: item.id,
                    ratio: item.ratio * 100
                })
            })

            this.targetWallet = row.id

            this.portId = portId;

            this.visable = true

            callback && (this.callback = callback)
        },
        hide() {
            this.visable = false
        },
        saveOnlyWallet(data) {
            let targetWallet = this.targetWallet;

            return new Promise((resolve, reject) => {
                this.axios({
                    method: 'post',
                    url: this.$API.setWalletRatio.replace('{id}', this.portId),
                    data: {
                        wallet: targetWallet,
                        wid: data.id,
                        r: data.ratio / 100
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.$Message.success(this.$t('lang.set_pump_by_w_script_6').replace('{targetWallet}', targetWallet).replace('{data.addr}', data.addr))
                        resolve()
                    } else {
                        this.$Message.error(this.$t('lang.set_pump_by_w_script_7'))
                        resolve()
                    }
                })
            })
        },
        async save() {
            for (let i = 0; i < this.portWallets.length; i++) {
                await this.saveOnlyWallet(this.portWallets[i])
            }

            this.hide()

            this.callback && this.callback()
        },
        reset() {
            this.axios({
                method: 'delete',
                url: this.$API.resetWalletRatio.replace('{id}', this.portId).replace('{wallet_name}', this.targetWallet)
            }).then(res => {
                if (res.status == 200) {
                    this.$Message.success(this.$t('lang.set_pump_by_w_script_8'))

                    this.hide()

                    this.callback && this.callback()
                } else {
                    this.$Message.error(this.$t('lang.set_pump_by_w_script_9'))
                }
            })
        }
    }
}
</script>

<style lang="scss">
.set-pump-by-wallet{
    .ivu-form-item-label{
        white-space: nowrap; /* 不换行 */
        text-overflow: ellipsis; /* 使用省略号表示溢出内容 */
        overflow: hidden;
    }
}
</style>

<style lang="scss">
@media screen and (max-width: $hideMenuWidth){
    .set-pump-by-wallet{
        width: 100%!important;
        max-width: 100%!important;
    }
}

.set-pump-by-wallet{
    margin: 0 auto;
    width: 50%;
    max-width: 600px;
    overflow: hidden!important;
    overflow-y: auto!important;

    .ivu-modal-body{
        padding: 0;
    }

    .box{
        padding: 20px;
    }
}
</style>
